import { render } from "./SpaceduckCollapse.vue?vue&type=template&id=086cefc4&scoped=true"
import script from "./SpaceduckCollapse.vue?vue&type=script&lang=js"
export * from "./SpaceduckCollapse.vue?vue&type=script&lang=js"

import "./SpaceduckCollapse.vue?vue&type=style&index=0&id=086cefc4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-086cefc4"]])

export default __exports__